// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* stylelint-disable declaration-property-value-disallowed-list -- DS */
:root {
    /* Menu Item */
    /* General */
    --ds-menu-item-outline-color: var(--ds-color-focus-outline);
    --ds-menu-item-active-color: var(--ds-color-grey-indigo-10);
    --ds-menu-item-disabled-color: var(--ds-color-grey-30);
    /* Standard */
    --ds-menu-item-color: var(--ds-color-grey-20);
    --ds-menu-item-hover-color: var(--ds-color-grey-10);
    /* Danger */
    --ds-menu-item-danger-color: var(--ds-color-error);
    --ds-menu-item-danger-hover-bg-color: var(--ds-color-negative-bg);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
